// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27%3E%3Cpath d=%27M0 0l6 8 6-8z%27 fill=%27%2398a2b3%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ProfessionalRegistration.module.css */

.ProfessionalRegistration_page__bjeB8 {
  min-height: 100vh;
  background-color: #f0f4f8;
  padding-top: 64px;
}

/* ── Header ── */
.ProfessionalRegistration_pageHeader__Q3oaM {
  background: #ffffff;
  border-bottom: 1px solid #e4e7ec;
  padding: 16px 20px;
}

.ProfessionalRegistration_headerInner__9IPJc {
  max-width: 960px;
  margin: 0 auto;
}

.ProfessionalRegistration_breadcrumb__5z3qM {
  font-size: 13px;
  color: #98a2b3;
  margin-bottom: 8px;
}

.ProfessionalRegistration_breadcrumb__5z3qM a {
  color: #98a2b3;
  text-decoration: none;
}

.ProfessionalRegistration_breadcrumb__5z3qM span {
  color: #344054;
  font-weight: 500;
}

.ProfessionalRegistration_headerRow__z1sAT {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 4px;
}

.ProfessionalRegistration_headerLeft__er0h9 h1 {
  font-size: 1.9rem;
  font-weight: 700;
  color: #1a3a5c;
  margin: 0 0 4px;
}

.ProfessionalRegistration_headerLeft__er0h9 p {
  font-size: 14px;
  color: #667085;
  margin: 0;
}

.ProfessionalRegistration_loginHint__8Z3op {
  font-size: 14px;
  color: #667085;
  white-space: nowrap;
}

.ProfessionalRegistration_loginHint__8Z3op a {
  color: #1a3a5c;
  font-weight: 600;
  text-decoration: none;
}

.ProfessionalRegistration_loginHint__8Z3op a:hover {
  text-decoration: underline;
}

/* ── Stepper ── */
.ProfessionalRegistration_stepper__kN2NU {
  display: flex;
  align-items: center;
  margin-top: 16px;
}

.ProfessionalRegistration_stepItem__9Tahf {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #98a2b3;
  font-weight: 500;
}

.ProfessionalRegistration_stepItem__9Tahf.ProfessionalRegistration_active__nuiUt {
  color: #1a3a5c;
  font-weight: 600;
}

.ProfessionalRegistration_stepCircle__RVHu- {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #d0d5dd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  color: #98a2b3;
  background: #fff;
  flex-shrink: 0;
}

.ProfessionalRegistration_stepItem__9Tahf.ProfessionalRegistration_active__nuiUt .ProfessionalRegistration_stepCircle__RVHu-,
.ProfessionalRegistration_stepItem__9Tahf.ProfessionalRegistration_done__Xf3G4 .ProfessionalRegistration_stepCircle__RVHu- {
  background: #2db899;
  border-color: #2db899;
  color: #fff;
}

.ProfessionalRegistration_stepLine__SrN9f {
  width: 60px;
  height: 2px;
  background: #d0d5dd;
  margin: 0 8px;
}

.ProfessionalRegistration_stepLine__SrN9f.ProfessionalRegistration_doneLine__2NNPJ {
  background: #2db899;
}

/* ── Contenido ── */
.ProfessionalRegistration_content__2p\\+Cr {
  max-width: 960px;
  margin: 36px auto;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ── Card ── */
.ProfessionalRegistration_card__og9\\+F {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  padding: 32px 36px;
  box-sizing: border-box;
}

.ProfessionalRegistration_stepLabel__Ifzl3 {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #2db899;
  margin-bottom: 4px;
}

.ProfessionalRegistration_cardTitle__KuBLp {
  font-size: 1.2rem;
  font-weight: 700;
  color: #1a3a5c;
  margin-bottom: 4px;
}

.ProfessionalRegistration_cardSubtitle__fBcFW {
  font-size: 13px;
  color: #667085;
  margin-bottom: 24px;
}

/* ── Grids ── */
.ProfessionalRegistration_formGrid__7cypF {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px 14px;
  margin-bottom: 24px;
}

.ProfessionalRegistration_formGrid3__P48bj {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px 14px;
  margin-bottom: 24px;
}

.ProfessionalRegistration_formGrid2__U\\+xAD {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px 14px;
  margin-bottom: 24px;
}

.ProfessionalRegistration_field__eFvPH {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

/* ── Inputs ── */
.ProfessionalRegistration_label__w0tnV {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #667085;
}

.ProfessionalRegistration_input__FNR2o {
  height: 40px;
  padding: 0 12px;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
  color: #344054;
  background: #fff;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.2s;
  font-family: inherit;
}

.ProfessionalRegistration_input__FNR2o:focus {
  border-color: #1a3a5c;
}

.ProfessionalRegistration_input__FNR2o::placeholder {
  color: #b0b8c4;
}

.ProfessionalRegistration_select__whykf {
  height: 40px;
  padding: 0 10px;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
  color: #344054;
  background: #fff
    url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    no-repeat right 12px center;
  appearance: none;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
  transition: border-color 0.2s;
  font-family: inherit;
}

.ProfessionalRegistration_select__whykf:focus {
  border-color: #1a3a5c;
}

/* ── Password field con eye ── */
.ProfessionalRegistration_passwordWrap__oSZ1a {
  position: relative;
}

.ProfessionalRegistration_passwordWrap__oSZ1a .ProfessionalRegistration_input__FNR2o {
  padding-right: 40px;
}

.ProfessionalRegistration_eyeBtn__mlBaj {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #98a2b3;
  padding: 0;
  display: flex;
  align-items: center;
}

/* ── Notas ── */
.ProfessionalRegistration_required__nI4Xy {
  font-size: 12px;
  color: #98a2b3;
  margin-bottom: 0;
}

/* ── Checkbox ── */
.ProfessionalRegistration_checkRow__Yg2K9 {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #344054;
}

.ProfessionalRegistration_checkRow__Yg2K9 input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #2db899;
  cursor: pointer;
  flex-shrink: 0;
}

.ProfessionalRegistration_checkRow__Yg2K9 a {
  color: #2db899;
  font-weight: 600;
  text-decoration: none;
}

/* ── Footer card ── */
.ProfessionalRegistration_cardFooter__eFycp {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 28px;
}

.ProfessionalRegistration_cardFooterRight__LbfY6 {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* ── Botones ── */
.ProfessionalRegistration_btnBack__B73ZT {
  padding: 10px 20px;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  background: transparent;
  color: #344054;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: border-color 0.2s;
}

.ProfessionalRegistration_btnBack__B73ZT:hover {
  border-color: #1a3a5c;
  color: #1a3a5c;
}

.ProfessionalRegistration_btnNext__ra-9K {
  padding: 10px 26px;
  background: #1a3a5c;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background-color 0.2s;
}

.ProfessionalRegistration_btnNext__ra-9K:hover {
  background: #142e4a;
}

.ProfessionalRegistration_btnSubmit__0WBox {
  padding: 10px 26px;
  background: #2db899;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background-color 0.2s;
}

.ProfessionalRegistration_btnSubmit__0WBox:hover {
  background: #25a085;
}

/* ── Responsive ── */
@media (max-width: 800px) {
  .ProfessionalRegistration_formGrid__7cypF {
    grid-template-columns: repeat(2, 1fr);
  }

  .ProfessionalRegistration_formGrid3__P48bj {
    grid-template-columns: repeat(2, 1fr);
  }

  .ProfessionalRegistration_card__og9\\+F {
    padding: 24px 20px;
  }

  .ProfessionalRegistration_stepLine__SrN9f {
    width: 32px;
  }
}

@media (max-width: 480px) {
  .ProfessionalRegistration_formGrid__7cypF,
  .ProfessionalRegistration_formGrid3__P48bj,
  .ProfessionalRegistration_formGrid2__U\\+xAD {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProfessionalRegistration/ProfessionalRegistration.module.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd;;+BAE6B;EAE7B,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ProfessionalRegistration.module.css */\n\n.page {\n  min-height: 100vh;\n  background-color: #f0f4f8;\n  padding-top: 64px;\n}\n\n/* ── Header ── */\n.pageHeader {\n  background: #ffffff;\n  border-bottom: 1px solid #e4e7ec;\n  padding: 16px 20px;\n}\n\n.headerInner {\n  max-width: 960px;\n  margin: 0 auto;\n}\n\n.breadcrumb {\n  font-size: 13px;\n  color: #98a2b3;\n  margin-bottom: 8px;\n}\n\n.breadcrumb a {\n  color: #98a2b3;\n  text-decoration: none;\n}\n\n.breadcrumb span {\n  color: #344054;\n  font-weight: 500;\n}\n\n.headerRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n\n.headerLeft h1 {\n  font-size: 1.9rem;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin: 0 0 4px;\n}\n\n.headerLeft p {\n  font-size: 14px;\n  color: #667085;\n  margin: 0;\n}\n\n.loginHint {\n  font-size: 14px;\n  color: #667085;\n  white-space: nowrap;\n}\n\n.loginHint a {\n  color: #1a3a5c;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.loginHint a:hover {\n  text-decoration: underline;\n}\n\n/* ── Stepper ── */\n.stepper {\n  display: flex;\n  align-items: center;\n  margin-top: 16px;\n}\n\n.stepItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #98a2b3;\n  font-weight: 500;\n}\n\n.stepItem.active {\n  color: #1a3a5c;\n  font-weight: 600;\n}\n\n.stepCircle {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 2px solid #d0d5dd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n  color: #98a2b3;\n  background: #fff;\n  flex-shrink: 0;\n}\n\n.stepItem.active .stepCircle,\n.stepItem.done .stepCircle {\n  background: #2db899;\n  border-color: #2db899;\n  color: #fff;\n}\n\n.stepLine {\n  width: 60px;\n  height: 2px;\n  background: #d0d5dd;\n  margin: 0 8px;\n}\n\n.stepLine.doneLine {\n  background: #2db899;\n}\n\n/* ── Contenido ── */\n.content {\n  max-width: 960px;\n  margin: 36px auto;\n  padding: 0 20px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ── Card ── */\n.card {\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);\n  padding: 32px 36px;\n  box-sizing: border-box;\n}\n\n.stepLabel {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: #2db899;\n  margin-bottom: 4px;\n}\n\n.cardTitle {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin-bottom: 4px;\n}\n\n.cardSubtitle {\n  font-size: 13px;\n  color: #667085;\n  margin-bottom: 24px;\n}\n\n/* ── Grids ── */\n.formGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px 14px;\n  margin-bottom: 24px;\n}\n\n.formGrid3 {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px 14px;\n  margin-bottom: 24px;\n}\n\n.formGrid2 {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px 14px;\n  margin-bottom: 24px;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n/* ── Inputs ── */\n.label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  color: #667085;\n}\n\n.input {\n  height: 40px;\n  padding: 0 12px;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #344054;\n  background: #fff;\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n  transition: border-color 0.2s;\n  font-family: inherit;\n}\n\n.input:focus {\n  border-color: #1a3a5c;\n}\n\n.input::placeholder {\n  color: #b0b8c4;\n}\n\n.select {\n  height: 40px;\n  padding: 0 10px;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #344054;\n  background: #fff\n    url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8'%3E%3Cpath d='M0 0l6 8 6-8z' fill='%2398a2b3'/%3E%3C/svg%3E\")\n    no-repeat right 12px center;\n  -webkit-appearance: none;\n  appearance: none;\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n  cursor: pointer;\n  transition: border-color 0.2s;\n  font-family: inherit;\n}\n\n.select:focus {\n  border-color: #1a3a5c;\n}\n\n/* ── Password field con eye ── */\n.passwordWrap {\n  position: relative;\n}\n\n.passwordWrap .input {\n  padding-right: 40px;\n}\n\n.eyeBtn {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #98a2b3;\n  padding: 0;\n  display: flex;\n  align-items: center;\n}\n\n/* ── Notas ── */\n.required {\n  font-size: 12px;\n  color: #98a2b3;\n  margin-bottom: 0;\n}\n\n/* ── Checkbox ── */\n.checkRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  color: #344054;\n}\n\n.checkRow input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #2db899;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.checkRow a {\n  color: #2db899;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n/* ── Footer card ── */\n.cardFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 28px;\n}\n\n.cardFooterRight {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n/* ── Botones ── */\n.btnBack {\n  padding: 10px 20px;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  background: transparent;\n  color: #344054;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: border-color 0.2s;\n}\n\n.btnBack:hover {\n  border-color: #1a3a5c;\n  color: #1a3a5c;\n}\n\n.btnNext {\n  padding: 10px 26px;\n  background: #1a3a5c;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: background-color 0.2s;\n}\n\n.btnNext:hover {\n  background: #142e4a;\n}\n\n.btnSubmit {\n  padding: 10px 26px;\n  background: #2db899;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: background-color 0.2s;\n}\n\n.btnSubmit:hover {\n  background: #25a085;\n}\n\n/* ── Responsive ── */\n@media (max-width: 800px) {\n  .formGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .formGrid3 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .card {\n    padding: 24px 20px;\n  }\n\n  .stepLine {\n    width: 32px;\n  }\n}\n\n@media (max-width: 480px) {\n  .formGrid,\n  .formGrid3,\n  .formGrid2 {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `ProfessionalRegistration_page__bjeB8`,
	"pageHeader": `ProfessionalRegistration_pageHeader__Q3oaM`,
	"headerInner": `ProfessionalRegistration_headerInner__9IPJc`,
	"breadcrumb": `ProfessionalRegistration_breadcrumb__5z3qM`,
	"headerRow": `ProfessionalRegistration_headerRow__z1sAT`,
	"headerLeft": `ProfessionalRegistration_headerLeft__er0h9`,
	"loginHint": `ProfessionalRegistration_loginHint__8Z3op`,
	"stepper": `ProfessionalRegistration_stepper__kN2NU`,
	"stepItem": `ProfessionalRegistration_stepItem__9Tahf`,
	"active": `ProfessionalRegistration_active__nuiUt`,
	"stepCircle": `ProfessionalRegistration_stepCircle__RVHu-`,
	"done": `ProfessionalRegistration_done__Xf3G4`,
	"stepLine": `ProfessionalRegistration_stepLine__SrN9f`,
	"doneLine": `ProfessionalRegistration_doneLine__2NNPJ`,
	"content": `ProfessionalRegistration_content__2p+Cr`,
	"card": `ProfessionalRegistration_card__og9+F`,
	"stepLabel": `ProfessionalRegistration_stepLabel__Ifzl3`,
	"cardTitle": `ProfessionalRegistration_cardTitle__KuBLp`,
	"cardSubtitle": `ProfessionalRegistration_cardSubtitle__fBcFW`,
	"formGrid": `ProfessionalRegistration_formGrid__7cypF`,
	"formGrid3": `ProfessionalRegistration_formGrid3__P48bj`,
	"formGrid2": `ProfessionalRegistration_formGrid2__U+xAD`,
	"field": `ProfessionalRegistration_field__eFvPH`,
	"label": `ProfessionalRegistration_label__w0tnV`,
	"input": `ProfessionalRegistration_input__FNR2o`,
	"select": `ProfessionalRegistration_select__whykf`,
	"passwordWrap": `ProfessionalRegistration_passwordWrap__oSZ1a`,
	"eyeBtn": `ProfessionalRegistration_eyeBtn__mlBaj`,
	"required": `ProfessionalRegistration_required__nI4Xy`,
	"checkRow": `ProfessionalRegistration_checkRow__Yg2K9`,
	"cardFooter": `ProfessionalRegistration_cardFooter__eFycp`,
	"cardFooterRight": `ProfessionalRegistration_cardFooterRight__LbfY6`,
	"btnBack": `ProfessionalRegistration_btnBack__B73ZT`,
	"btnNext": `ProfessionalRegistration_btnNext__ra-9K`,
	"btnSubmit": `ProfessionalRegistration_btnSubmit__0WBox`
};
export default ___CSS_LOADER_EXPORT___;
